module.exports = __webpack_public_path__ + "img/cust_tooltips_twisto_mticket.46b242b9.webp";